export enum CmsType
{
    HTML,
    Image,
    Text,
    File

}